import { detectEntityTypeFromUrl } from "./resourceDetection";

import { EntityType, isSupportedEntityType } from "@/queries/folder-entities/types";

enum ToolVisualType {
  PROMPT = "prompt",
  WORKFLOW = "workflow",
  DATASET = "dataset",
  EVALUATION = "evaluation",
  SCORECARD = "scorecard",
  SMART_TABLE = "smart_table",
  FOLDER = "folder",
  SKILL = "skill",
  AB_TEST = "ab_test",
  INPUT_VARIABLE_SET = "input_variable_set",
  TOOL = "tool",
}

export const isScorecardVisualType = (type: string): boolean => type === ToolVisualType.SCORECARD;

export const isScorecardNavigation = (url: string, label?: string): boolean =>
  url.includes("/scorecard") || Boolean(label?.toLowerCase().includes("scorecard"));

export const resolveEntityTypeFromToolType = (type: string): EntityType | null => {
  switch (type) {
    case ToolVisualType.PROMPT:
      return EntityType.PROMPT;
    case ToolVisualType.WORKFLOW:
      return EntityType.WORKFLOW;
    case ToolVisualType.DATASET:
      return EntityType.DATASET;
    case ToolVisualType.EVALUATION:
      return EntityType.REPORT;
    case ToolVisualType.SCORECARD:
      return null;
    case ToolVisualType.SMART_TABLE:
      return EntityType.SMART_TABLE;
    case ToolVisualType.FOLDER:
      return EntityType.FOLDER;
    case ToolVisualType.SKILL:
      return EntityType.SKILL_COLLECTION;
    case ToolVisualType.AB_TEST:
      return EntityType.AB_TEST;
    case ToolVisualType.INPUT_VARIABLE_SET:
      return EntityType.INPUT_VARIABLE_SET;
    case ToolVisualType.TOOL:
      return EntityType.TOOL;
    default:
      return isSupportedEntityType(type) ? type : null;
  }
};

export const resolveEntityTypeFromNavigation = (url: string, label?: string): EntityType | null => {
  if (isScorecardNavigation(url, label)) {
    // Scorecard navigation uses the Score Gauge icon in ToolNavigationButtons.
    return null;
  }

  return detectEntityTypeFromUrl(url);
};
